import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService, UrlParam } from './classes/BaseService';
import { FileUploadListener } from './classes/FileUploadListener';
import { Observable, Observer } from 'rxjs';

@Injectable()
export class OwnListService extends BaseService {

  apiUrl = 'Ownlist.php?';

  constructor(protected http: HttpClient) {
    super(http);
  }

  getDetailItemList(sessionToken: string, store: string, mediaType: string, country: string,
    genreIds: string, quality: string, sort: string, offset: number, limit: number) {

    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam('action', 'getDetailItemList'),
      new UrlParam('store', store),
      new UrlParam('mediaType', mediaType),
      new UrlParam('country', country),
      new UrlParam('genreIds', genreIds),
      new UrlParam('quality', quality),
      new UrlParam('sort', sort),
      new UrlParam('offset', offset.toString()),
      new UrlParam('limit', limit.toString()),
      new UrlParam('sessionToken', sessionToken)
    );

    return this.get(url);

  }

  getShortItemList(sessionToken: string, store: string, country: string) {

    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam('action', 'getShortItemList'),
      new UrlParam('store', store),
      new UrlParam('country', country),
      new UrlParam('sessionToken', sessionToken)
    );

    return this.get(url);

  }

  addItem(country: string, store: string, itemType: string, sessionToken: string, idInStore: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam('country', country),
      new UrlParam('store', store),
      new UrlParam('action', 'addItem'),
      new UrlParam('itemType', itemType),
      new UrlParam('idInStore', idInStore)
    );

    return this.post(url, this.buildUrlParams(new UrlParam('sessionToken', sessionToken)));
  }

  removeItem(country: string, store: string, itemType: string, sessionToken: string, idInStore: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam('country', country),
      new UrlParam('store', store),
      new UrlParam('action', 'removeItem'),
      new UrlParam('itemType', itemType),
      new UrlParam('idInStore', idInStore)
    );

    return this.post(url, this.buildUrlParams(new UrlParam('sessionToken', sessionToken)));
  }

  search(country: string, store: string, mediaType: string, searchTerm: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam('action', 'search'),
      new UrlParam('store', store),
      new UrlParam('mediaType', mediaType),
      new UrlParam('country', country),
      new UrlParam('searchTerm', searchTerm),
      new UrlParam('sessionToken', sessionToken)
    );

    return this.get(url);
  }

  importMediaLibrary(blob: Blob, fileUploadListener: FileUploadListener, country: string,
    store: string, mediaTypes: string, sessionToken: string): Observable<any> {

    return Observable.create((observer: Observer<any>) => {
      const formData: FormData = new FormData();
      const name = "mediaLibrary";
      formData.append(name, blob, name);

      const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
        new UrlParam('action', 'importMediaLibrary'),
        new UrlParam('store', store),
        new UrlParam('mediaTypes', mediaTypes),
        new UrlParam('country', country),
        new UrlParam('sessionToken', sessionToken)
      );
      const xhr = new XMLHttpRequest();

      // 10 minutes – import can take long for large libraries (1400+ items)
      xhr.timeout = 600000;
      xhr.ontimeout = function () {
        observer.error('timeout');
      };

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(xhr.response);
            observer.complete();
          }
          else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (e) => {
        if (fileUploadListener) {
          fileUploadListener.onProgress(blob, e.loaded / e.total * 100);
        }
      };

      //Here the post is done with a XMLHttpRequest because we want the onprogress event
      xhr.open('POST', url, true);
      xhr.send(formData);
    });

  }

  importMediaLibrary_v2(base64StringData: string, country: string, store: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam('country', country),
      new UrlParam('store', store),
      new UrlParam('action', 'importMediaLibrary_v2')
    );

    return this.post(url, this.buildUrlParams(
      new UrlParam('sessionToken', sessionToken),
      new UrlParam("data", base64StringData)
    ));
  }

  getShareOwnListUrl(country: string, store: string, mediaType: string, sessionToken: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "getShareOwnlistUrl"),
      new UrlParam("mediaType", mediaType),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("debug", "0")
    );

    return this.get(url);
  }

}
